(function () {
  'use strict';
  var mq = window.matchMedia('(max-width: 749px)');
  function build(rec) {
    var grid = rec.querySelector('.product-grid');
    if (!grid || rec.querySelector('.ew-rel__nav')) return;
    var items = grid.querySelectorAll('.grid__item');
    if (items.length < 2) return;
    var nav = document.createElement('div');
    nav.className = 'ew-rel__nav';
    var dots = '';
    for (var i = 0; i < items.length; i++) dots += '<button type="button" aria-label="Product ' + (i + 1) + '"' + (i === 0 ? ' class="is-on"' : '') + '></button>';
    nav.innerHTML = '<button type="button" class="ew-rel__arrow" data-rel-prev aria-label="Previous"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg></button>' +
      '<div class="ew-rel__dots">' + dots + '</div>' +
      '<button type="button" class="ew-rel__arrow" data-rel-next aria-label="Next"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg></button>';
    grid.insertAdjacentElement('afterend', nav);
    var dotEls = nav.querySelectorAll('.ew-rel__dots button'), current = 0;
    function step() { return items[1].offsetLeft - items[0].offsetLeft; }
    function go(i) {
      i = (i + items.length) % items.length;
      grid.scrollTo({ left: items[i].offsetLeft - items[0].offsetLeft, behavior: 'smooth' });
    }
    grid.addEventListener('scroll', function () {
      current = Math.round(grid.scrollLeft / step());
      dotEls.forEach(function (d, k) { d.classList.toggle('is-on', k === current); });
    }, { passive: true });
    dotEls.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
    nav.querySelector('[data-rel-prev]').addEventListener('click', function () { go(current - 1); });
    nav.querySelector('[data-rel-next]').addEventListener('click', function () { go(current + 1); });
    /* mouse: drag to scroll */
    var down = false, startX = 0, startLeft = 0, moved = false;
    grid.addEventListener('mousedown', function (e) { if (!mq.matches) return; down = true; moved = false; startX = e.pageX; startLeft = grid.scrollLeft; grid.style.scrollSnapType = 'none'; });
    window.addEventListener('mousemove', function (e) { if (!down) return; var dx = e.pageX - startX; if (Math.abs(dx) > 4) moved = true; grid.scrollLeft = startLeft - dx; });
    window.addEventListener('mouseup', function () { if (!down) return; down = false; grid.style.scrollSnapType = ''; go(Math.round(grid.scrollLeft / step())); });
    grid.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
  }
  function init() {
    document.querySelectorAll('product-recommendations').forEach(function (rec) {
      build(rec);
      if (rec.dataset.ewRel) return; rec.dataset.ewRel = '1';
      new MutationObserver(function () { build(rec); }).observe(rec, { childList: true, subtree: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();